<template>
  <span>
    {{value}}
  </span>
</template>

<script>
export default {
  name: 'TemplateDate',
  props: {
    row: { type: Object, required: true },
    col: { type: Object, required: true },
    template: { type: Object, required: true }
  },
  computed: {
    value () {
      const val = this.row[this.col.field]
      if (!val) {
        return ''
      }
      return this.$moment(val).format(this.template.format || 'DD/MM/YYYY')
    }
  }
}
</script>
